/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
import env from "Consts/env";
import vars from "Consts/vars";
import moment from "moment";
import Axios from "./axios";

export const checkDevice = (device) => {

	if (device.match(/iPhone|iPad|iPod/i)) return "iPhone";

	return device.match(
		/Android|BlackBerry|Opera Mini|IEMobile|WPDesktop/i,
	) ? "Android" : false;

};

export const imageSrc = ({ image }) => {

	const img = image ? image.split("://") : [];

	if (image) {

		if (img.length > 1) {

			return `//${img[1]}`;

		}

		return image;

	}

	return "//static.femaledaily.com/dyn/400/images/user-pics/placeholder_user.png";

};

export const injectAltImage = (query, value) => {

	const btnClosetop = document.querySelector(`.${query}`);
	btnClosetop ? btnClosetop.setAttribute("alt", value) : null;

};

export async function AdsDetik(site, params) {

	try {

		const urls = ["canary", "production"].includes(process.env.NEXT_PUBLIC_NODE_ENV)
			? "https://detikads.femaledaily.com/static/ads/femaledaily/"
			: "https://detikads.femaledaily.com/static/ads/femaledaily/staging_femaledaily/";
		const res = await fetch(`${urls + site}/${params}.txt`);

		return await res.text();

	} catch (error) {

		process.exit(1);

	}

}

export function ScrollToUp() {

	window.scrollTo({
		top: 0,
		behavior: "smooth",
	});

}

export const getToday = () => moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss");
export const utc_to_local = (params) => {

	const utc = moment.utc(params.date).toDate();
	const res = moment(utc).local().format("YYYY-MM-DD HH:mm:ss");
	return res;

};

export const moment_date = ({ date }) => {

	const local_date = utc_to_local({ date });
	const res = moment(local_date).add(7, "days").isBefore(moment())
		? moment(local_date).format("DD MMM YYYY")
		: moment(local_date).fromNow();
	return res;

};

export const stringUrl = (params) => {

	const tmp = Array.isArray(params)
		? params[params.length - 1].replace(/[-]/g, " ")
		: params.replace(/[-]/g, " ");

	return tmp;

};

export const slugUrl = (params) => {

	const tmp = Array.isArray(params) ? params[params.length - 1] : params;

	return tmp;

};

export const categoryName = (slug, categories) => {

	const slugs = Array.isArray(slug) ? slug[slug.length - 1] : slug;

	const tmp = categories.filter((item) => item.slug.replace(/[_]/g, "-") === slugs)[0].name;

	return tmp;

};

export async function fetcher(...args) {

	const res = await fetch(...args);

	return res.json();

}

// export const setGTM = () => {

// 	const GTM = process.env.NEXT_PUBLIC_GTM_ID;

// 	return {
// 		__html: `
// 			(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
// 			new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
// 			j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
// 			'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
// 			})(window,document,'script','dataLayer','${GTM}');
// 			function gtag(){dataLayer.push(arguments);}
// 			gtag('js', new Date());
// 			gtag('config', '${GTM}');
// 			`,
// 	};

// };

export const setGTM = () => {

	const GTM = process.env.NEXT_PUBLIC_GTM_ID;

	return {
		__html: `
			(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
			new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
			j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
			'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer','${GTM}');
		`,
	};

};

export const setGTMNoScript = () => {

	const GTM = process.env.NEXT_PUBLIC_GTM_ID;

	return {
		__html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
	};

};

// export const comScore = () => ({
// 	__html: `
// 			var _comscore = _comscore || [];
// 			_comscore.push({ c1: "2", c2: "8443234" });
// 			(function() {
// 			var s = document.createElement("script"), el = document.getElementsByTagName("script")[0]; s.async = true;
// 			s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
// 			el.parentNode.insertBefore(s, el);
// 			})();
// 		`,
// });

// export const comScoreNoScript = () => ({
// 	__html: `
// 		<img src="https://sb.scorecardresearch.com/p?c1=2&c2=8443234&cv=2.0&cj=1" />
// 	`,
// });

// export const setGoogleAnalytics = () => {

// 	const GaGeneral = process.env.NEXT_PUBLIC_GA_GENERAL_ID;

// 	return {
// 		__html: `
// 		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
// 			(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
// 			m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
// 		})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

// 		ga('create', '${GaGeneral}', 'auto', 'fdn');
// 		ga('fdn.send', 'pageview');
// 		`,
// 	};

// };

export const setGoogleAnalytics = () => {

	const GaGeneral = process.env.NEXT_PUBLIC_GA_GENERAL_ID;
	const GaHost = process.env.NEXT_PUBLIC_GA_HOST_ID;

	return {
		__html: `
	  var _gaq = _gaq || [];
    _gaq.push(['_setAccount', '${GaHost}']);
    _gaq.push(['_trackPageview']);

    _gaq.push(['fdn._setAccount', '${GaGeneral}']);
    _gaq.push(['fdn._setDomainName', 'femaledaily.com']);
    _gaq.push(['fdn._setAllowLinker', true]);
    _gaq.push(['fdn._trackPageview']);

    (function() {
      var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
      ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
      var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
    })();  
	  `,
	};

};

export const setGoogleAnalyticsNoscript = () => {

	const GaGeneral = process.env.NEXT_PUBLIC_GA_GENERAL_ID;

	return {
		__html: `
		<iframe src="https://www.googletagmanager.com/ns.html?id=${GaGeneral}"
		height="0" width="0" style="display:none;visibility:hidden"></iframe>
		`,
	};

};

export const setGoogleAnalyticsNoscriptGaHost = () => {

	const GaHost = process.env.NEXT_PUBLIC_GA_HOST_ID;

	return {
		__html: `
		<iframe src="https://www.googletagmanager.com/ns.html?id=${GaHost}"
		height="0" width="0" style="display:none;visibility:hidden"></iframe>
		`,
	};

};

export const setFBPixel = () => ({
	__html: `
		!function(b,e,f,g,a,c,d)
		{b.fbq||(a=b.fbq=function()
		{a.callMethod?a.callMethod.apply(a,arguments):a.queue.push(arguments)},
		b._fbq||(b._fbq=a),a.push=a,a.loaded=!0,a.version="2.0",a.queue=[],c=e.createElement(f),
		c.async=!0,c.src=g,d=e.getElementsByTagName(f)[0],d.parentNode.insertBefore(c,d))}
		(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");
		fbq("init","1198820543828675");fbq("set","agent","tmgoogletagmanager","1198820543828675");fbq("track","PageView");
	`,
});

export const setFBPixelNoScript = () => ({
	__html: `
	<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1198820543828675&amp;ev=PageView&amp;noscript=1">
	`,
});

export const setHotjar = () => ({
	__html: `
		 (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:2515136,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=')
	`,
});

export const setAMPAlexametrics = () => ({
	__html: "<script type=\"application/json\"> {\"vars\": { \"atrk_acct\": \"5TYNs1O7kI20L7\", \"domain\": \"review.femaledaily.com\" }}</script>",
});

export const handleImage = (url, width, pathfile) => {

	const IMAGE_ENDPOINT = `//image.femaledaily.com/dyn/${width}/images/${pathfile}-pics/`;
	// url must string, not object
	// if no data url, set placeholder image user
	let placeholder = "placeholder_user.png";
	if (pathfile === "prod") {

		placeholder = "placeholder_product.png";

	}
	if (width) {

		return url
			? RegExp("femaledaily.com").test(url)
				? `//image.femaledaily.com/dyn/${
					width
				}/images${
					url.split("images")[1]}`
				: IMAGE_ENDPOINT + url
			: IMAGE_ENDPOINT + placeholder;

	}
	return url
		? RegExp("femaledaily.com").test(url)
			? `//image.femaledaily.com/images${url.split("images")[1]}`
			: IMAGE_ENDPOINT + url
		: IMAGE_ENDPOINT + placeholder;

};

export const imageDynamic = (url, width) => {

	if (url?.match(/assets.femaledaily.com/g) && !url.match(/%/g)) {

		return (
			`https://image.femaledaily.com/dyn/${
				width
			}${url.split("assets.femaledaily.com")[1]}`
		);

	}
	return url;

};

export const imageDynamic2 = (url, width) => {

	if (url.match(/image.femaledaily.com/g) && !url.match(/%/g)) {

		return (
			`https://image.femaledaily.com/dyn/${
				width
			}/images${
				url.split("images")[1]}`
		);

	}
	return url;

};

export const Fetching = async (params) => {

	try {

		const result = await Axios({
			method: params.method,
			url: `/api-new/${params.url}/`,
			data: params.data,
			headers: { ...env.HEADERS },
		});

		return result;

	} catch (error) {

		throw new Error("Error response");

	}

};

export const setVideoWidget = () => ({
	__html: `
			var mobile = Boolean(window.navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
			var bottomAds = !!document.getElementById("sb_mobile_sticky")

			Video.config({
				isMobile: mobile,
				unique_code: "fd2kale",
				selector: "#vidwidget",
        domain2: "${process.env.NEXT_PUBLIC_ROOT_DOMAIN}",
				isAds: bottomAds,
				position: "fixed",
        elementId: "videoWidgetStreaming",
			});

		Video.widgets.render();
		`,
});

export const checkImageViews = (url) => {

	if (url.includes("assets.femaledaily.com") || url.includes("image.femaledaily.com")) {

		return url;

	}
	return vars.IMAGE_ERROR;

};

export const numberHandle = (n) => {

	const number = n.toString();
	const len = number.length;
	const place = len % 3 || 3;
	let abb;
	switch (true) {

	case len > 9:
		abb = "B";
		break;
	case len > 6:
		abb = "M";
		break;
	case len > 4:
		abb = "K";
		break;
	default:
		return number;

	}

	return `${number.slice(0, place)}.${number.slice(place, place + 1)}${abb}`;

};

export const beautyLevelHandle = (level) => {

	const word = level.toLowerCase();

	switch (word) {

	case "platinum":
		return "platinum";
	case "diamond":
		return "diamond";
	case "silver":
		return "silver";
	case "bronze":
		return "bronze";
	default:
		return "bronze";

	}

};

export const setDataLayer = (dataObj, urlTarget) => {

	if (typeof window === "undefined") return;
	const dataLayer = window.dataLayer || undefined;
	if (typeof dataLayer === "undefined") return;
	if (urlTarget === "GTM") {

		if (typeof dataObj === "object" && dataObj !== null) {

			dataLayer.push(dataObj);

		}

	} else {

		// eslint-disable-next-line consistent-return
		return {
			clickProductDetail: (payload) => {

				dataLayer.push({
					event: payload.event || "click_product_detail",
					username: payload.username,
					is_login: payload.is_login || false,
					device: payload.device || "desktop",
				});

			},
			clickBrandDetail: (payload) => {

				dataLayer.push({
					event: payload.event || "click_brand_detail",
					username: payload.username,
					is_login: payload.is_login || false,
					device: payload.device || "desktop",
				});

			},
			viewPopupCompleteProfile: (payload) => {

				dataLayer.push({
					event: payload.event || "view_popup_complete_profile",
					username: payload.username,
					is_login: payload.is_login || false,
					device: payload.device || "desktop",
					referral: payload.referral || "reviews",
				});

			},
		};

	}

};

export const Rupiah = (props) => {

	const reverse = props.toString().split("").reverse().join("");
	const ribuan = reverse.match(/\d{1,3}/g) || [];
	const final = ribuan.join(".").split("").reverse().join("");

	return `Rp. ${final}`;

};

export const ThousandSeparator = (props) => {

	const reverse = props.toString().split("").reverse().join("");
	const ribuan = reverse.match(/\d{1,3}/g) || [];
	const final = ribuan?.join(".").split("").reverse().join("");

	return final;

};

export const getImageUrlHighlight = (assets) => {

	if (
		Array.isArray(assets)
					&& assets.length > 0
					&& assets[0]?.url?.match(/image.femaledaily.com/)
	) {

		return imageDynamic2(assets[0]?.url, 80);

	} if (Array.isArray(assets) && assets.length > 0) {

		return imageDynamic(assets[0]?.url, 80);

	}
	return "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/images/user-review/image-review-broken.png";

};
